import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from 'projects/bis-shared/src/lib/dialog/dialog.service';
import { AppUrls } from '../utility/appurls';
import { InternalApiUrls } from '../utility/apiurls-internal';
import { ExternalApiUrls } from '../utility/apiurls-external';
import { EnvironmentService } from '../environment/environment.service';
import { IdleService } from '../utility/idle.service';
import {
  WillHandleErrorMessagingOption,
  RetryOption,
  CombineOptions,
} from '../utility/http-options';

@Component({
  selector: 'lib-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  private force: boolean;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private internalApiUrls: InternalApiUrls,
    private externalApiUrls: ExternalApiUrls,
    private identityService: IdentityService,
    private router: Router,
    private dialogService: DialogService,
    private environmentService: EnvironmentService,
    private idleService: IdleService,
  ) {}

  ngOnInit(): void {
    //TODO: Need to do this a better way. Shouldn't need to pass in query params to log the user out of Otka. Can we emit an event instead?
    this.route.queryParamMap.subscribe(queryParams => {
      const doLogout = queryParams.get('doLogout') === 'true';
      this.force = queryParams.get('force') === 'true';
      if (queryParams.get('state') === 'showIdleLogoutWarning') {
        this.idleService.showIdleLogoutWarning = true;
      }
      const logOutUrl = this.environmentService.isExternalSite
        ? this.externalApiUrls.user.logout()
        : this.internalApiUrls.user.logout();

      if (doLogout) {
        // Invalidate the user's auth info in our API
        this.http
          .post(
            logOutUrl,
            { refreshToken: this.identityService?.apiToken?.refreshToken },
            CombineOptions([RetryOption, WillHandleErrorMessagingOption]),
          )
          .subscribe(
            // Regardless of success or failure, logout the user from Okta
            () => {
              this.identityService.logout(this.idleService.showIdleLogoutWarning);
              this.completeLogout();
            },
            (error: HttpErrorResponse) => {
              // check error, only logout with redirect if the network has a non-zero response
              if (error.status !== 0) {
                this.identityService.logout(this.idleService.showIdleLogoutWarning);
              }

              this.completeLogout();
            },
          );
      } else {
        this.completeLogout();
      }
    });
  }

  private completeLogout() {
    this.dialogService.closeOpenDialogs();
    this.identityService.reset();
    if (this.force) {
      this.identityService.forceLogout = true;
    }

    if (this.environmentService.isExternalSite) {
      this.router.navigate([AppUrls.login()]);
    } else {
      this.router.navigate([AppUrls.logout()], {
        skipLocationChange: true,
      });
    }
    if (this.idleService.showIdleLogoutWarning) {
      this.dialogService.showUnsavedWarningAfterIdleLogout();
      this.idleService.showIdleLogoutWarning = false;
    }
  }
}
